/* eslint-disable @typescript-eslint/no-explicit-any */
export const getSortBy = (columns) => {
    const sortedColumn = columns.find(({ isSortable, initialSort }) => isSortable && initialSort);
    if (!sortedColumn)
        return null;
    const getId = () => {
        const { id, accessor } = sortedColumn;
        if (typeof id === 'string')
            return id;
        if (typeof accessor === 'string')
            return accessor;
        return null;
    };
    const id = getId();
    if (!id)
        return null;
    return {
        sortBy: [
            {
                id,
                desc: sortedColumn.initialSort === 'desc',
            },
        ],
    };
};
//# sourceMappingURL=getSortBy.js.map